<template>
  <v-dialog
    v-model="opened"
    content-class="update-status"
    max-width="350"
    persistent
  >
    <h3>{{ $t('common.btns.edit') }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="update-status-dialog" class="mt-4" @submit.prevent="onSubmit">
      <v-select
        v-if="!onlyComment"
        v-model="formData.status"
        item-text="title"
        item-value="id"
        :label="$t('driversList.tableHeaders.status')"
        :loading="propsLoading"
        :items="statuses"
        :rules="[isRequired]"
        :item-disabled="isStatusDisabled"
        dense
        outlined
      />
      <v-textarea
        v-model="formData.statusComment"
        :label="$t('driversList.tableHeaders.statusComment')"
        dense
        outlined
        height="100"
        no-resize
      />

      <v-btn
        class="mt-1"
        type="submit"
        color="warning"
        elevation="0"
        block
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    onlyComment: {
      type: Boolean,
      default: false,
    },
    data: {
      default: null,
    },
  },
  data: () => ({
    loading: false,
    propsLoading: false,
    formData: {
      status: '',
      statusComment: '',
    },
  }),
  watch: {
    opened(val) {
      if (val) {
        this.fetchProperties();
        this.formData.status = this.data.status;
        this.formData.statusComment = this.data.statusComment;
      } else {
        this.$refs['update-status-dialog'].reset();
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    statuses() {
      return this.$store.getters['driver/getDriversVerificationStatuses'];
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    isStatusDisabled({ id }) {
      return id !== 4 && id !== 5;
    },
    async fetchProperties() {
      this.propsLoading = true;
      await this.$store.dispatch('driver/fetchDriversProperties');
      this.propsLoading = false;
    },
    async onSubmit() {
      const isValid = this.$refs['update-status-dialog'].validate();

      if (!isValid) return;

      this.loading = true;

      const result = await this.$store.dispatch('driver/editDriver', {
        driverId: this.data.id,
        data: {
          status: this.formData.status,
          statusComment: this.formData.statusComment,
        },
      });

      if (result.success) this.opened = false;

      this.$emit('updated', result);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.update-status {
  padding: 10px;
  background-color: #fff;
}
</style>
